// src/App.js
import React, { useState, useEffect } from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // 🔥 FORCE ROOT
    if (window.location.pathname !== "/") {
      window.history.replaceState({}, "", "/");
    }

    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    setAuthChecked(true);
  }, []);

  if (!authChecked) return <div>Loading...</div>;

  return user ? (
    <Dashboard user={user} setUser={setUser} />
  ) : (
    <Login setUser={setUser} />
  );
}

export default App;